import React from 'react';
import { Menu, MenuItem, ListItemIcon, ListItemText } from '@mui/material';
import { Delete as DeleteIcon } from '@mui/icons-material';

function ContextMenu({ contextMenu, handleClose, handleDelete, selectedItem }) {
  return (
    <Menu
      open={contextMenu !== null}
      onClose={handleClose}
      anchorReference="anchorPosition"
      anchorPosition={
        contextMenu !== null
          ? { top: contextMenu.mouseY, left: contextMenu.mouseX }
          : undefined
      }
    >
      <MenuItem onClick={handleDelete}>
        <ListItemIcon>
          <DeleteIcon fontSize="small" />
        </ListItemIcon>
        <ListItemText>
          {selectedItem?.type === 'folder' ? 'Excluir Pasta' : 'Excluir Arquivo'}
        </ListItemText>
      </MenuItem>
    </Menu>
  );
}

export default ContextMenu; 